import React, { useContext } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { colors } from '@mobi/component-library/Foundations'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { TeamShieldColorsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon/Components/TeamIcon/Components/Common/TeamColorShield'
import { TeamIconContext } from '@mobi/sports-offering/Components/Common/TeamsIcon/Components/TeamIcon/TeamIconProvider'
import type {
  DefaultIconType,
  SportIconSize,
} from '@mobi/sports-offering/Components/Common/TeamsIcon/types'

export const DefaultIcon: React.FC<{
  defaultIconType: DefaultIconType
  sportName?: KambiSportName
  size: SportIconSize
}> = ({ sportName, defaultIconType, size }) => {
  const { shouldLoadDefaultIcon } = useContext(TeamIconContext)
  if (!shouldLoadDefaultIcon) return null

  if (defaultIconType === 'sport-icon' && sportName) {
    return <SportsIcon size={sizeMap[size]} sport={sportName} />
  }

  if (defaultIconType === 'team-icon') {
    return (
      <TeamShieldColorsIcon
        size={size}
        colors={{ team: '', mainColor: colors.white, secondaryColor: '#EDEDED' }}
      />
    )
  }

  return null
}

// =============
// Local Helpers
// =============

const sizeMap: Record<SportIconSize, string> = {
  xxs: '1.6rem',
  xs: '2rem',
  sm: '2.4rem',
  md: '2.8rem',
  lg: '3.2rem',
  xl: '3.6rem',
}
